import { Link } from "react-router-dom";
import { Facebook, Instagram, Menu, X, Youtube } from "lucide-react";
import { useState } from "react";

export default function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <header className="sticky top-0 z-50 bg-white shadow-md">
            <div className="px-4 mx-auto max-w-[85rem] sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-20">
                    <Link to={"/athena-study-hall"}>
                        <div className="flex-shrink-0">
                            <img src="/images/Studyhall/logo.jpg" alt="Study Hall Logo" loading="lazy" className="object-contain h-auto rounded-lg w-36 sm:w-44"/>
                        </div>
                    </Link>

                    <nav className="items-center hidden gap-8 md:flex">
                        <Link to="/athena-study-hall" className="text-gray-700 hover:text-[#602233] font-semibold text-lg transition-colors duration-200 relative group">Home
                            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#602233] group-hover:w-full transition-all duration-300"></span>
                        </Link>
                        <Link to="/athena-study-hall" className="text-gray-700 hover:text-[#602233] font-semibold text-lg transition-colors duration-200 relative group">About Us
                            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#602233] group-hover:w-full transition-all duration-300"></span>
                        </Link>
                        <Link to="/athena-study-hall/gallery" className="text-gray-700 hover:text-[#602233] font-semibold text-lg transition-colors duration-200 relative group">Gallery
                            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#602233] group-hover:w-full transition-all duration-300"></span>
                        </Link>
                    </nav>

                    <div className="hidden md:block">
                        <div className="flex gap-5">
                            <Link to={"/athena-study-hall/book-seats"}>
                                <button className="bg-[#602233] hover:bg-[#4a1a28] text-white font-semibold px-6 py-3 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg transform  ">
                                    Book Your Seat Now
                                </button>
                            </Link>
                            <div className="flex items-center justify-center gap-2">
                                <Link to={"https://www.instagram.com/athenastudyhall/"} target="_blank">
                                    <div className="flex items-center justify-center w-8 h-8 text-white bg-pink-500 rounded-full">
                                        <Instagram size={18}/>
                                    </div>
                                </Link>
                                <Link to={"https://www.facebook.com/athenastudyhall"} target="_blank">
                                    <div className="flex items-center justify-center w-8 h-8 text-white bg-blue-600 rounded-full">
                                        <Facebook size={18}/>
                                    </div>
                                </Link>
                                <Link to={"https://www.youtube.com/@AthenaStudyHall"} target="_blank">
                                    <div className="flex items-center justify-center w-8 h-8 text-white bg-red-600 rounded-full">
                                        <Youtube size={18}/>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                   
                    <button className="p-2 transition-colors rounded-lg md:hidden hover:bg-gray-100" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu">
                        {isMenuOpen ? (
                            <X className="w-6 h-6 text-gray-700" />
                        ) : (
                            <Menu className="w-6 h-6 text-gray-700" />
                        )}
                    </button>
                </div>

                {isMenuOpen && (
                    <div className="py-4 space-y-4 border-t border-gray-200 md:hidden">
                        <Link to="/athena-study-hall" className="block text-gray-700 hover:text-[#602233] font-medium text-lg py-2 px-4 hover:bg-gray-50 rounded-lg transition-colors"
                            onClick={() => setIsMenuOpen(false)}>
                            Home
                        </Link>
                        <Link to="/athena-study-hall" className="block text-gray-700 hover:text-[#602233] font-medium text-lg py-2 px-4 hover:bg-gray-50 rounded-lg transition-colors"
                            onClick={() => setIsMenuOpen(false)}>
                            About Us
                        </Link>
                        <Link to="/athena-study-hall/gallery" className="block text-gray-700 hover:text-[#602233] font-medium text-lg py-2 px-4 hover:bg-gray-50 rounded-lg transition-colors"
                            onClick={() => setIsMenuOpen(false)}>
                            Gallery
                        </Link>
                        <Link to={"/athena-study-hall/book-seats"}>
                            <button className="w-full bg-[#602233] hover:bg-[#4a1a28] text-white font-semibold px-6 py-3 rounded-lg transition-all duration-300 shadow-md">
                                Book Your Seat Now
                            </button>
                        </Link>
                    </div>
                )}
            </div>
        </header>
    );
}